import PropTypes from 'prop-types'
import React, { Component } from 'react'
import './style.scss'

export class LineLabel extends Component {
  static propTypes = {}

  getStyles = () => {
    const {item} = this.props;
    return {
      left: item.startX > item.endX ? item.endX - 200 : item.endX,
      top: item.endY - 25,
    }
  }

  render() {
    const { item } = this.props;
    return (
      <div style={this.getStyles()} className='ItemQestionBlock'>
        {item.value}
      </div>
    )
  }
}

export default LineLabel


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/Questions/components/Item/components/Answers/components/AnswerType6/components/LineLabel/LineLabel.jsx